import { render, staticRenderFns } from "./Evaluation.vue?vue&type=template&id=674df6ea&scoped=true"
import script from "./Evaluation.vue?vue&type=script&lang=js"
export * from "./Evaluation.vue?vue&type=script&lang=js"
import style0 from "./Evaluation.vue?vue&type=style&index=0&id=674df6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674df6ea",
  null
  
)

export default component.exports